export const iconFontAwesomeSportsFitnessBaseballBatBall = (
	<i className="fa-solid fa-baseball-bat-ball"></i>
);
